import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
import { createSysGroup, deleteSysGroup as _deleteSysGroup, deleteSysGroupByIds, updateSysGroup, findSysGroup, getSysGroupList } from "@/api/sys_group"; //  此处请自行替换地址
import { formatTimeToStr } from "@/utils/data";
import infoList from "@/components/mixins/infoList";
import { getDict } from "@/utils/dictionary";
import Users from "@/view/superAdmin/group/components/users";
import Reports from "@/view/superAdmin/group/components/reports";
import Forms from "@/view/superAdmin/group/components/forms";
import Files from "@/view/superAdmin/group/components/files";
import { formatJson } from "@/utils";
import { debounce } from 'lodash';
export default {
  name: "SysGroup",
  mixins: [infoList],
  components: {
    Users: Users,
    Reports: Reports,
    Forms: Forms,
    Files: Files
  },
  data: function data() {
    return {
      listApi: getSysGroupList,
      dialogFormVisible: false,
      dialogTitle: "",
      active: "users",
      drawer: false,
      activeRow: {},
      visible: false,
      isUsedOptions: [],
      type: "",
      deleteVisible: false,
      multipleSelection: [],
      formData: {
        code: null,
        nameZh: null,
        nameEn: null,
        createby: null,
        inused: null,
        isdelete: null,
        updateby: null,
        deletedby: null
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? "是" : "否";
      } else {
        return "";
      }
    }
  },
  methods: {
    //:before-leave="autoEnter"
    // autoEnter(activeName, oldActiveName) {
    //   const paneArr = ["users", "reports","files"];
    //   if (oldActiveName) {
    //     if (this.$refs[paneArr[oldActiveName]].needConfirm) {
    //       this.$refs[paneArr[oldActiveName]].enterAndNext();
    //       this.$refs[paneArr[oldActiveName]].needConfirm = false;
    //     }
    //   }
    // },
    tabClick: function tabClick(tab, event) {
      console.log('name ,' + tab.name);
      this.active = tab.name;
    },
    inusedFilter: function inusedFilter(value) {
      var target = this.isUsedOptions.filter(function (item) {
        return item.value === parseInt(value.inused);
      })[0];
      return target && "".concat(target.label);
    },
    addGroup: function addGroup() {
      this.isEdit = false;
      this.dialogTitle = "Group-New";
      this.dialogFormVisible = true;
    },
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    opdendrawer: function opdendrawer(row) {
      this.active = "users";
      this.drawer = true;
      this.activeRow = row;
    },
    onDelete: function () {
      var _onDelete = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ids, res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ids = [];
              this.multipleSelection && this.multipleSelection.map(function (item) {
                ids.push(item.ID);
              });
              _context.next = 1;
              return deleteSysGroupByIds({
                ids: ids
              });
            case 1:
              res = _context.sent;
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: 'success'
                });
                this.deleteVisible = false;
                this.getTableData();
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onDelete() {
        return _onDelete.apply(this, arguments);
      }
      return onDelete;
    }(),
    updateSysGroup: function () {
      var _updateSysGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return findSysGroup({
                ID: row.ID
              });
            case 1:
              res = _context2.sent;
              this.type = "update";
              if (res.code == 0) {
                this.formData = res.data.resysGroup;
                this.dialogTitle = "Group-Edit";
                this.dialogFormVisible = true;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateSysGroup(_x) {
        return _updateSysGroup.apply(this, arguments);
      }
      return updateSysGroup;
    }(),
    closeDialog: function closeDialog() {
      this.dialogFormVisible = false;
      this.formData = {
        code: null,
        nameZh: null,
        nameEn: null,
        createby: null,
        inused: null,
        isdelete: null,
        updateby: null,
        deletedby: null
      };
    },
    deleteSysGroup: function () {
      var _deleteSysGroup2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$confirm(this.$t('common.delete_warning'), "", {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var res;
                return regeneratorRuntime.wrap(function (_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _this.visible = false;
                      _context3.next = 1;
                      return _deleteSysGroup({
                        ID: row.ID
                      });
                    case 1:
                      res = _context3.sent;
                      if (!(res.code == 0)) {
                        _context3.next = 2;
                        break;
                      }
                      _this.$message({
                        type: "success",
                        message: _this.$t('common.success')
                      });
                      _context3.next = 2;
                      return _this.getTableData();
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }))).catch(function () {
                _this.$message({
                  type: "info",
                  message: _this.$t('common.cancel')
                });
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function deleteSysGroup(_x2) {
        return _deleteSysGroup2.apply(this, arguments);
      }
      return deleteSysGroup;
    }(),
    enterDialog: function () {
      var _enterDialog = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _t = this.type;
              _context5.next = _t === "create" ? 1 : _t === "update" ? 3 : 5;
              break;
            case 1:
              _context5.next = 2;
              return createSysGroup(this.formData);
            case 2:
              res = _context5.sent;
              return _context5.abrupt("continue", 7);
            case 3:
              _context5.next = 4;
              return updateSysGroup(this.formData);
            case 4:
              res = _context5.sent;
              return _context5.abrupt("continue", 7);
            case 5:
              _context5.next = 6;
              return createSysGroup(this.formData);
            case 6:
              res = _context5.sent;
              return _context5.abrupt("continue", 7);
            case 7:
              if (!(res.code == 0)) {
                _context5.next = 8;
                break;
              }
              this.$message({
                type: "success",
                message: "success"
              });
              this.closeDialog();
              _context5.next = 8;
              return this.getTableData();
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function enterDialog() {
        return _enterDialog.apply(this, arguments);
      }
      return enterDialog;
    }(),
    openDialog: function openDialog() {
      this.type = "create";
      this.dialogFormVisible = true;
    },
    handleExport: function handleExport() {
      var _this2 = this;
      // const queryParams = this.queryParams
      this.$confirm(this.$t('common.delete_warning'), "", {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this2.downloadLoading = true;
        import('@/vendor/Export2Excel').then(function (excel) {
          var tHeader = [_this2.$t('usergroup.name_zh'), _this2.$t('usergroup.name_en')];
          var filterVal = ['nameZh', 'nameEn'];
          var list = _this2.tableData;
          // eslint-disable-next-line no-undef
          var data = formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data: data,
            filename: _this2.$t('usergroup.user_group_management'),
            autoWidth: true,
            // Optional
            bookType: 'xlsx' // Optional
          });
          _this2.downloadLoading = false;
        });
      }).catch(function () {});
    }
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var res;
      return regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 1;
            return this.getTableData();
          case 1:
            _context6.next = 2;
            return getDict("groupIsUsed");
          case 2:
            res = _context6.sent;
            this.isUsedOptions = res;
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};